import { fg } from '@atlaskit/platform-feature-flags/fg';
import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';
import {
	isTerminalTaskState,
	StoreActionLoggableName,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { abortRequests } from './abortRequests';
import { createSafeAction, type SafeAction } from './createSafeAction';
import type { ChatStoreAction } from './types';

type StopTaskArgs = { conversationId: string };

export const stopTask: SafeAction<[StopTaskArgs]> = createSafeAction(
	StoreActionLoggableName.stopTask,
	({ conversationId }: StopTaskArgs): ChatStoreAction =>
		({ getState, dispatch }, { assistanceService, unifiedTasksActions }) => {
			if (!fg('rovo_chat_enable_tasks')) {
				return;
			}

			const conversation = getState().conversations[conversationId];
			if (conversation?.storeAbortController) {
				dispatch(abortRequests({ conversationId, taskModeEnabled: true }));
				return;
			}

			if (!unifiedTasksActions) {
				return;
			}

			const task = unifiedTasksActions.getActiveTaskForConversation(conversationId);
			if (!task?.taskId || isTerminalTaskState(task.progressState)) {
				return;
			}

			unifiedTasksActions.setTaskProgressState({
				taskId: task.taskId,
				progressState: 'Cancelled',
				updatedAt: new Date().toISOString(),
			});

			void assistanceService.cancelTask(task.taskId).catch((err: unknown) => {
				logException({
					name: 'rovoCancelTaskFromStopTask',
					exception: err,
					tags: { taskId: task.taskId },
				});
			});
		},
);
